import React from 'react'


const NumberInput = ({ label, value, onChange, min = 0, max = 100 }) => {
  const handleDecrease = () => onChange(Math.max(min, value - 1))
  const handleIncrease = () => onChange(Math.min(max, value + 1))

  return (
    <div className="flex items-center justify-between mb-4">
      <span className="text-sm font-medium text-gray-700">{label}</span>
      <div className="flex items-center">
        <button
          onClick={handleDecrease}
          className="p-1 rounded-full bg-gray-200 text-gray-600 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
          aria-label={`Decrease ${label}`}
        >
          -
        </button>
        <span className="mx-2 w-8 text-center">{value}</span>
        <button
          onClick={handleIncrease}
          className="p-1 rounded-full bg-gray-200 text-gray-600 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
          aria-label={`Increase ${label}`}
        >
          +
        </button>
      </div>
    </div>
  )
}


const SliderInput = ({ label, value, onChange, min = 0, max = 100 }) => {
  return (
    <div className="mb-4">
      <div className="flex justify-between mb-1">
        <span className="text-sm font-medium text-gray-700">{label}</span>
        <span className="text-sm font-medium text-gray-700">{value}%</span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
        style={{
          background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${value}%, #e5e7eb ${value}%, #e5e7eb 100%)`,
        }}
      />
    </div>
  )
}

export default function EditModel({
  fontSize,
  setFontSize,
  headingTextSize,
  setHeadingTextSize,
  watermarkSize,
  setWatermarkSize,
  watermarkOpacity,
  setWatermarkOpacity
}) {

  return (
    <div className="mx-auto p-4 bg-white rounded-lg shadow-md">
      <NumberInput
        label="Font Size"
        value={fontSize}
        onChange={setFontSize}
        min={8}
        max={24}
      />
      <NumberInput
        label="Heading Text Size"
        value={headingTextSize}
        onChange={setHeadingTextSize}
        min={8}
        max={36}
      />
      <SliderInput
        label="Watermark Size"
        value={watermarkSize}
        onChange={setWatermarkSize}
      />
      <SliderInput
        label="Watermark Opacity"
        value={watermarkOpacity}
        onChange={setWatermarkOpacity}
      />
    </div>
  )
}